import { useState, useEffect } from 'react';
import api from '../../../services/api';
import DataTable from '../componentes/DataTable';
import EditModal from '../componentes/EditModal';
import DeleteConfirm from '../componentes/DeleteConfirm';
import { Plus } from 'lucide-react';

const HistorialPanel = () => {
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const fetchHistorial = async () => {
    try {
      setLoading(true);
      const res = await api.get('/historial');
      setHistorial(res.data?.data || res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchHistorial(); }, []);

  const handleEdit = (h) => {
    setSelected({ ...h });
    setShowEdit(true);
  };

  const handleCreate = () => {
    setSelected(null);
    setShowEdit(true);
  };

  const handleDelete = (id) => {
    setSelected(historial.find(h => h.id === id));
    setShowDelete(true);
  };

  const handleSave = async (formData) => {
    if (selected) {
      await api.put(`/historial/${selected.id}`, formData);
    } else {
      await api.post('/historial', formData);
    }
    setShowEdit(false);
    fetchHistorial();
  };

  const confirmDelete = async () => {
    await api.delete(`/historial/${selected.id}`);
    setShowDelete(false);
    fetchHistorial();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'id_mascota', label: 'Mascota ID' },
    { key: 'titulo', label: 'Título' },
    { key: 'tipo_evento', label: 'Tipo' },
    { key: 'fecha_evento', label: 'Fecha' },
    { key: 'completada', label: 'Completada', render: (v) => v == 1 ? 'Sí' : 'No' },
    { key: 'recordatorio', label: 'Recordatorio', render: (v) => v == 1 ? 'Sí' : 'No' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800 }}>Historial / Agenda</h1>
        <button className="sp-btn sp-btn--primary" onClick={handleCreate}>
          <Plus size={18} /> Nuevo
        </button>
      </div>

      <DataTable
        columns={columns}
        data={historial}
        loading={loading}
        error={error}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {showEdit && (
        <EditModal
          title={selected ? 'Editar evento' : 'Crear evento'}
          fields={[
            { name: 'id_mascota', label: 'ID Mascota', type: 'number' },
            { name: 'id_contacto', label: 'ID Contacto (opcional)', type: 'number' },
            { name: 'fecha_evento', label: 'Fecha evento', type: 'date' },
            { name: 'proxima_fecha', label: 'Próxima fecha', type: 'date' },
            { name: 'titulo', label: 'Título' },
            { name: 'nota', label: 'Nota', type: 'textarea' },
            { name: 'tipo_evento', label: 'Tipo (vacuna, cita, etc.)' },
            { name: 'laboratorio', label: 'Laboratorio' },
            { name: 'lote', label: 'Lote' },
            { name: 'notas', label: 'Notas adicionales', type: 'textarea' },
            { name: 'completada', label: 'Completada', type: 'checkbox' },
            { name: 'recordatorio', label: 'Recordatorio', type: 'checkbox' },
          ]}
          initialValues={selected || {}}
          onSave={handleSave}
          onCancel={() => setShowEdit(false)}
        />
      )}

      {showDelete && (
        <DeleteConfirm
          message={`¿Eliminar el evento "${selected.titulo}"?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default HistorialPanel;